"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.twitterShareAction = exports.TwitterButton = void 0;
var _icons = require("../../assets/icons");
var _sharing_helper = require("../../helpers/sharing_helper");
var _base = require("./base");
var twitterShareAction = exports.twitterShareAction = function twitterShareAction(_ref) {
  var shareUrl = _ref.shareUrl,
    utmParams = _ref.utmParams;
  return (0, _sharing_helper.openPopup)("https://twitter.com/intent/tweet?url=".concat((0, _sharing_helper.encodedShareURL)(shareUrl, utmParams), "&via=betterplace_org"));
};
var TwitterButton = exports.TwitterButton = (0, _base.buildShareButtonComponent)({
  action: twitterShareAction,
  ariaLabel: 'Twitter',
  className: 'share-button--twitter',
  icon: _icons.TwitterIcon
});